import React from 'react';
import {
  canonicalOpportunityStatus,
  getOpportunityStatusColor,
  mapStatusOptionsWithColors,
} from './opportunityStatusOptions.js';

export function resolveOpportunityStatusColor(status) {
  return getOpportunityStatusColor(canonicalOpportunityStatus(status));
}

/** Match All Opportunities status filter chips (react-select multiValue). */
export function getOpportunityStatusChipStyle(status, selected = true) {
  const color = resolveOpportunityStatusColor(status);
  if (selected) {
    return {
      backgroundColor: `${color}22`,
      color,
      boxShadow: `inset 0 0 0 1px ${color}44`,
      fontWeight: 600,
    };
  }
  return {
    backgroundColor: '#f3f4f6',
    color: '#374151',
    boxShadow: 'inset 0 0 0 1px #e5e7eb',
    fontWeight: 500,
  };
}

export function formatOpportunityStatusOptionLabel({ label, color, value }) {
  return (
    <span className="flex items-center gap-2">
      <span
        className="h-2 w-2 shrink-0 rounded-full"
        style={{ backgroundColor: color || getOpportunityStatusColor(value) }}
      />
      <span>{label}</span>
    </span>
  );
}

export function formatOpportunityStatusGroupLabel({ label, color }) {
  return (
    <span className="flex items-center gap-2">
      <span
        className="h-2 w-2 shrink-0 rounded-full"
        style={{ backgroundColor: color }}
      />
      <span>{label}</span>
    </span>
  );
}

export function findGroupedStatusOption(options, value) {
  if (!value) return null;
  for (const group of options) {
    const match = group.options?.find((option) => option.value === value);
    if (match) return match;
  }
  return {
    value,
    label: value,
    color: getOpportunityStatusColor(value),
  };
}

export function sanitizeStatusFilterSelection(selected) {
  if (!Array.isArray(selected)) return [];
  return selected.filter((option) => option?.value !== 'Temporarily Close');
}

export function flattenStatusFilterOptions(options) {
  if (!Array.isArray(options)) return [];
  return options.flatMap((option) => (Array.isArray(option.options) ? option.options : [option]));
}

export function withStatusColors(statuses) {
  return mapStatusOptionsWithColors(
    statuses.map((value) => ({ value, label: value }))
  );
}
